const firebaseConfig = {
  apiKey: "AIzaSyCs9o-uy0t5qcan0ccjvxnWlnbgWiPHgwQ",
  authDomain: "travel-agency-d1c0d.firebaseapp.com",
  projectId: "travel-agency-d1c0d",
  storageBucket: "travel-agency-d1c0d.appspot.com",
  messagingSenderId: "768431574666",
  appId: "1:768431574666:web:3fb5590a25b711eeeca773"
};
  export default firebaseConfig;